import React from "react";
import TopDiagnosticsNonDtcComplaints from "../../Diagnostics/TopNonDtcComplaints/TopNonDtcComplaints";

const TopNonDtcComplaints = () => {
  return <TopDiagnosticsNonDtcComplaints route="prognostics" />;
};

export default TopNonDtcComplaints;
